import { Config, AuthHeader } from "../helpers/Config";

export const DocumentService = {
    /**
     * [GET_DOCUMENTS]
     */
    GetDocuments() {

        var requestOptions = {
            method: 'GET',
            headers: AuthHeader()
        }

        return DocumentService.Common.Fetch(Config.service.document.getDocument, requestOptions);
    },
    /**
  * [DOCUMENTKEY]
  */
    DocumentKey(data) {

        var requestOptions = {
            method: 'POST',
            headers: AuthHeader(),
            body: JSON.stringify(data)
        }

        return DocumentService.Common.Fetch(Config.service.document.documentKey, requestOptions);
    },


    /**
    * [COMMON]
    * @function Fetch
    */
    Common: {
        Fetch(url, requestOptions) {

            return fetch(url, requestOptions)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401) {

                        window.location.reload();

                    } else {
                        throw new Error();
                    }
                }).then((json) => {
                    return json;
                }).catch(function () {
                    return false;
                });

        }
    }
}





